(() => {
  const KEY = 'loniu_saved_items_v1';

  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (e) {
      return [];
    }
  };

  const write = (items) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(items.slice(0, 60)));
    } catch (e) {}
  };

  const saveButtons = () => document.querySelectorAll('[data-save-product]');

  const syncButtons = () => {
    const items = read();
    saveButtons().forEach((button) => {
      const saved = items.some((item) => item.handle === button.dataset.productHandle);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.textContent = saved ? button.dataset.labelSaved : button.dataset.labelSave;
      const container = button.closest('.product-save-for-later');
      const view = container ? container.querySelector('[data-saved-items-link]') : null;
      if (view) view.hidden = !items.length;
    });
  };

  const toggle = (button) => {
    let items = read();
    const handle = button.dataset.productHandle;
    const index = items.findIndex((item) => item.handle === handle);

    if (index >= 0) {
      items.splice(index, 1);
    } else {
      items.unshift({
        handle,
        title: button.dataset.productTitle || '',
        url: button.dataset.productUrl || '',
        image: button.dataset.productImage || '',
        price: button.dataset.productPrice || ''
      });
    }

    write(items);
    syncButtons();
    renderSavedItems();
  };

  const renderSavedItems = () => {
    const grid = document.querySelector('[data-saved-items-grid]');
    if (!grid) return;

    const items = read();
    const empty = document.querySelector('[data-saved-items-empty]');
    const count = document.querySelector('[data-saved-items-count]');

    grid.replaceChildren();
    if (count) count.textContent = String(items.length);
    if (empty) empty.hidden = items.length > 0;

    items.forEach((item) => {
      const card = document.createElement('article');
      card.className = 'saved-item-card';

      const link = document.createElement('a');
      link.href = item.url || '#';
      link.className = 'saved-item-card__media';

      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.title || '';
        image.loading = 'lazy';
        link.appendChild(image);
      }

      const body = document.createElement('div');
      body.className = 'saved-item-card__body';

      const title = document.createElement('h2');
      title.className = 'saved-item-card__title';
      const titleLink = document.createElement('a');
      titleLink.href = item.url || '#';
      titleLink.textContent = item.title || '';
      title.appendChild(titleLink);

      const price = document.createElement('p');
      price.className = 'saved-item-card__price';
      price.textContent = item.price || '';

      const actions = document.createElement('div');
      actions.className = 'saved-item-card__actions';

      const view = document.createElement('a');
      view.href = item.url || '#';
      view.className = 'button button--secondary';
      view.textContent = grid.dataset.viewLabel || 'View product';

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'link underlined-link saved-item-card__remove';
      remove.textContent = grid.dataset.removeLabel || 'Remove';
      remove.addEventListener('click', () => {
        write(read().filter((saved) => saved.handle !== item.handle));
        syncButtons();
        renderSavedItems();
      });

      actions.append(view, remove);
      body.append(title, price, actions);
      card.append(link, body);
      grid.appendChild(card);
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-save-product]');
    if (!button) return;
    toggle(button);
  });

  document.addEventListener('DOMContentLoaded', () => {
    syncButtons();
    renderSavedItems();
  });

  document.addEventListener('shopify:section:load', () => {
    syncButtons();
    renderSavedItems();
  });
})();